import styled, { css } from 'styled-components';
import theme from '../../styles/material';
import background from '../../assets/images/chat2.jpeg';
import { IconButton } from '@material-ui/core';
import InputBase from '@material-ui/core/InputBase';
import colors from '../../styles/colors';

export const Input = styled(InputBase)`
  width: 100%;
  border: none;
  padding-left: 20px;
  padding-right: 20px;
`;
export const InputContainer = styled.div`
  width: 100%;
  border-radius: 10px;
  padding-left: 20px;
  padding-right: 20px;
  border: 1px solid #f0f0f0;
  background-color: #fff;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
  Input {
    border: none;
    background-color: transparent;
    flex: 1;
  }
  img {
    height: 24px;
    width: 24px;
  }
`;

const getColor = (props) => {
  if (props.isDragAccept) {
    return '#2196f3';
  }
  if (props.isDragReject) {
    return '#ff1744';
  }
  return '#eeeeee';
};

export const Container = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  width: 100%;
  background-color: #f0f0f0;
  z-index: 1;
`;

export const DropArea = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.8);
  border: ${(props) => (props.isDragActive ? '2px dashed' : 'none')};
  border-color: ${(props) => getColor(props)};
  color: ${(props) => getColor(props)};
  font-size: 18px;
  z-index: 10;
`;
export const Content = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  padding: 25px 5rem 0px 5rem;
  background-color: #f0f0f0;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const SendContent = styled.form`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  // background-color: #e0e0e0;
  align-items: center;
  justify-content: center;
  column-gap: 10px;
  width: 100%;
  svg {
    // color: ${theme.palette.secondary.main};
    font-size: 26px;
    cursor: pointer;
  }
  button {
    border: none;
    background-color: transparent;
  }
  label {
    input {
      display: none;
    }
  }
`;

export const BottomContent = styled.div`
  flex-shrink: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f0f0f0;
  border: none;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 6px 5rem 14px 5rem;
  box-sizing: border-box;
  z-index: 1;
`;

export const ButtonClose = styled(IconButton)`
  padding: 0px !important;
`;

export const ButtonScrollDown = styled.div`
  position: absolute;
  bottom: 10px;
  right: 30px;
  background-color: ${colors.primary} !important;
  color: #fff !important;
  height: 36px;
  width: 36px;
  border-radius: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
`;
export const Unread = styled.div`
  padding: 8px;
  margin: 10px 0px;
  background: #e0e0e0;
  border-radius: 10px;
  color: #999;
  text-align: center;
`;
export const RepliedMessage = styled.div`
  padding-left: 5px;
  padding-right: 5px;
  border-left: 2px solid #666;
  text-align: left;
  min-height: 30px;
  margin-bottom: 10px;
`;
export const MessageContent = styled.div`
  // background-color: #e0e0e0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding: 5px;
  // padding-bottom: 0px;
  z-index: 100;
`;

export const PreviewContainer = styled.div`
  display: flex;
`;

export const ForwardText = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  position: absolute;
  top: 2px;
  left: 2px;
  font-size: 12px;
  column-gap: 2px;
  color: #999;
`;

export const MessageMarked = styled.div`
  background: #fff;
  position: relative;
  width: 100%;
  padding: 20px 20px 10px 10px;
  overflow: hidden;
  font-size: 14px;
  border-radius: 10px;
  ${ButtonClose} {
    position: absolute;
    top: 5px;
    right: 5px;
  }
`;
export const BalloonDate = styled.div`
  position: absolute;
  right: 20px;
  bottom: 6px;
  padding: 2px;
  font-size: 11px;
`;
export const BalloonActions = styled.div`
  position: absolute;
  top: 0px;
  right: 5px;
  color: #999;
  transition: visibility 0.1ms;
`;

export const BalloonInfo = styled.div`
  position: absolute;
  right: 4px;
  bottom: 0px;
  svg {
    width: 15px;
  }
`;
export const AttachmentContainer = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin: 0px;
  justify-content: left;
  gap: 8px;
  padding-bottom: 5px;
`;

export const AttachmentFile = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    height: 120px;
    cursor: pointer;
  }
`;
export const Balloon = styled.div`
  min-width: 130px;
  max-width: 550px;
  margin: 10px;
  border-radius: 5px;
  padding: 20px 10px;
  text-align: left;
  font-weight: 500;
  font-family: arial;
  position: relative;

  padding-bottom: 30px;
  margin-bottom: 20px;

  ${BalloonActions} {
    visibility: hidden;
  }

  ${(props) =>
    props.isDeleted &&
    css`
      padding-bottom: 15px;
    `}

  ${(props) =>
    props.isToday &&
    css`
      min-width: 55px;
    `}

    ${(props) =>
      props.isForward &&
      props.isToday &&
      css`
        min-width: 100px !important;
        background-color: red;
      `}

  ${(props) =>
    props.my === false &&
    css`
    text-align:left;
    align-self:flex-start;
    box-shadow: 2px 2px 3px 1px rgba(0, 0, 0, 0.2);
    background-color:#fff;
    color: #000 !important;
  &:before {
    content: "";
    width: 0px;
    height: 0px;
    position: absolute;
    border-left: 10px solid transparent;
    border-right: 10px solid #fff;
    border-top: 10px solid #fff;
    border-bottom: 10px solid transparent;
    left: -10px;
    top: 6px;
  `}

  ${(props) =>
    props.my === true &&
    css`
    text-align:right;
    align-self:flex-end;
    box-shadow: -2px 2px 3px 1px rgba(0, 0, 0, 0.2);
    background-color: #f9fbe7;
    color:#333;
  &:before {
    content: "";
    width: 0px;
    height: 0px;
    position: absolute;
    border-left: 10px solid #f9fbe7;
    border-right: 10px solid transparent;
    border-top: 10px solid #f9fbe7;
    border-bottom: 10px solid transparent;
    right: -10px;
    top: 6px;
  `}
  }
  &:hover {
    ${BalloonActions} {
      visibility:visible;
    }
`;

export const FileDetailsContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 5px 8px 10px 8px;
  text-align: left;
  font-size: 11px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const FileName = styled.div`
  color: black;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-bottom: 5px;
`;

export const FileTypeSize = styled.div`
  font-size: 10px;
`;

export const FilesPreviewContainer = styled.div`
  max-height: 300px;
  overflow-y: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  border-radius: 10px;
  background-color: #e0e0e0;
`;
